<div *ngIf="decision.screen !== 'app'"
     class="mag-overlay fixed inset-0 z-[95] flex items-center justify-center bg-white p-6">
  <div class="w-full max-w-sm text-center">

    <!-- The app's own identity. This is a customer's end user, so our mark has no place here. -->
    <img *ngIf="iconUrl" [src]="iconUrl" alt="" class="w-20 h-20 mx-auto rounded-2xl mb-5">
    <p *ngIf="appName" class="text-lg font-semibold text-[#332D2C]">{{ appName }}</p>

    <ng-container *ngIf="decision.screen === 'install'">
      <h1 class="text-xl font-semibold text-[#332D2C] mt-3">{{ installTitle }}</h1>

      <ng-container *ngIf="decision.platform === 'android'">
        <p class="text-sm text-gray-600 mt-3">{{ androidIntro }}</p>
        <!-- Always rendered, not gated on installAvailable: beforeinstallprompt can arrive after this
             view already painted (or never, if Chrome already decided the criteria aren't met), and a
             visitor who is told "install the app" needs something tappable from the first frame. A tap
             before the event fires reveals the written steps below — see install() — rather than doing
             nothing at all. -->
        <button type="button" (click)="install()"
                class="mt-5 w-full rounded-lg bg-[#332D2C] text-white text-sm font-medium py-3">
          {{ androidButton }}
        </button>

        <!-- Revealed once a tap proves the button has nothing to trigger — no captured prompt, or a
             rejected one. Without this the button is a dead end when Chrome never offers the API. -->
        <ol *ngIf="showAndroidSteps"
            class="mt-4 text-left text-sm text-gray-600 space-y-2 list-decimal list-inside">
          <li *ngFor="let step of androidFallbackSteps">{{ step }}</li>
        </ol>
      </ng-container>

      <ol *ngIf="decision.platform !== 'android'"
          class="mt-4 text-left text-sm text-gray-600 space-y-2 list-decimal list-inside">
        <li *ngFor="let step of iosSteps">{{ step }}</li>
      </ol>

      <!-- ALWAYS RENDERED, whatever detectBrowser returned. On iOS, Add to Home Screen does not exist
           inside an app's embedded browser, and links arrive that way more often than not. Without
           this line the instructions above are impossible to follow and the gate becomes a wall. -->
      <p class="mt-6 pt-4 border-t border-gray-200 text-xs text-gray-500">{{ escapeLine }}</p>
    </ng-container>

    <ng-container *ngIf="decision.screen === 'unavailable'">
      <h1 class="text-xl font-semibold text-[#332D2C] mt-3">{{ unavailableTitle }}</h1>
      <!-- Text only, by decision: no download link, no button. -->
      <p class="text-sm text-gray-600 mt-3">{{ unavailableBody }}</p>
    </ng-container>

  </div>
</div>
